<style lang="scss" scoped></style>
<template lang="pug">
article.message.is-danger
  .message-header
    p {{ header }}
    button.delete(aria-label='delete')
  .message-body(v-html="body")
</template>
<script>
export default {
  name: "Alert",
  props: {
    header: {
      type: String,
      default: "An Error Has Occured"
    },
    body: {
      type: String,
      default: "Please contact johnmarkbeaty@gmail.com for assistance."
    }
  },
  data() {
    return {};
  }
};
</script>
